import JobRecommendations from "./JobRecommendations";

export default JobRecommendations;
